import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get_attendance, get_salary as _get_salary } from 'api/payroll/salary-scheme/detail';
import { tabPaneArr } from '../../../salary-scheme/detail/conf';
import taxInfo from '../../../salary-scheme/detail/tab3-tax';
import otherInfo from '../../../salary-scheme/detail/tab5-setting.vue';
import securityInfo from '../../../salary-scheme/detail/tab4-security.vue';
export default {
  components: {
    taxInfo: taxInfo,
    otherInfo: otherInfo,
    securityInfo: securityInfo
  },
  props: {
    projectSchemeId: {
      type: String
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      tableData: {},
      dataForm: {},
      day_hour: {
        id: '',
        val: '',
        type: '',
        name: ''
      },
      activeData: tabPaneArr[0].data,
      activeData1: tabPaneArr[1].data,
      fixTable: {
        name: '',
        list: []
      },
      // 上边的表格
      days: [],
      // 下拉框
      not_days: [],
      // 下拉框
      fixTableSelectArr: [],
      // 上面表格选中的
      activeNames: [],
      activeNames1: [],
      activeNames2: [],
      notFixTable: {
        id: '',
        list: [{
          id: '',
          list: [{
            id: ''
          }] // 表格的行
        }, {
          id: '',
          list: [] // 表格的行
        }, {
          id: '',
          list: [] // 表格的行
        }]
      },

      // 下面的表格
      notFixTableSelectArr: [],
      obj: {},
      fixSelect: {},
      is_show: false,
      // 是否展示全勤奖
      attendanceData: {}
    };
  },
  methods: {
    init: function init(item) {
      this.curr = item;
      this.dialogVisible = true;
      this.getAttendance();
      this.get_salary();
    },
    getAttendance: function getAttendance() {
      var _this = this;
      // 记薪方案详情数据
      get_attendance({
        payroll_sub_project_scheme_id: this.curr.payroll_sub_project_scheme_id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this.day_hour = res.data.day_hour; // day_hour
          _this.tableData = res.data.list; // 表格
          _this.$nextTick(function () {
            _this.tableData.forEach(function (collapseItem, index) {
              collapseItem.columns.forEach(function (v) {
                if (v.is_select === '1') {
                  _this.$refs['table' + index][0].toggleRowSelection(v, true);
                }
              });
            });
          });
        }
      });
    },
    get_salary: function get_salary() {
      var _this2 = this;
      // 工资设置数据
      _get_salary({
        payroll_sub_project_scheme_id: this.curr.payroll_sub_project_scheme_id
      }).then(function (res) {
        if (res && res.code === 1) {
          var _res$data = res.data,
            fix = _res$data.fix,
            notfix = _res$data.notfix,
            days = _res$data.days,
            not_days = _res$data.not_days;
          _this2.fixTable = fix;
          _this2.notFixTable = notfix;
          _this2.days = days;
          _this2.not_days = not_days;
          var formatData = [{
            data: fix,
            key: 'fixTable'
          }, {
            data: notfix,
            key: 'notFixTable'
          }];
          // 全勤奖有数据展示
          if (_this2.is_show) {
            _this2.notFixTable.list.push({
              name: _this2.$t('payroll_management_20'),
              list: [],
              id: ''
            });
          }
          formatData.map(function (v, i) {
            v.data.list.forEach(function (table, tableIndex) {
              table.list.forEach(function (item) {
                item.cate_id = table.id;
                item.is_tax = item.is_tax === '1';
                item.is_ss = item.is_ss === '1';
                item.is_ewf = item.is_ewf === '1';
                _this2.$nextTick(function () {
                  if (item.is_select === '1') {
                    _this2.$refs["".concat(v.key).concat(tableIndex)][0].toggleRowSelection(item, true);
                  }
                });
              });
            });
          });
        }
      });
    },
    selectable: function selectable() {
      return false;
    }
  }
};